export default "__VITE_ASSET__CcvldxIg__"